











import FieldModel from '@/UI/Shared/Mixins/FieldModel'
import CustomMultiselect from '@/UI/Shared//CustomMultiselect.vue'
import mixins from 'vue-typed-mixins'
import {
  FetchStreetTypeCommandHandlerProvider
} from '@/Infrastructure/Localization/StreetType/Provider/FetchStreetTypeCommandHandlerProvider'
import { FetchStreetTypeCommand, StreetTypeDto } from '@/Application/Localization'
import { i18n } from '@/Infrastructure/Intl/Intl'
interface Options {
  id: string;
  label: string;
}

interface data {
  loading: boolean;
  options: Options[]
}

export default mixins(FieldModel).extend({
  name: 'StreetTypeSelector',
  components: { CustomMultiselect },
  props: {
    label: {
      type: String,
      required: true
    }
  },
  data ():data {
    return {
      loading: true,
      options: []
    }
  },
  computed: {
    buttonClass (): string {
      return this.loading ? 'fa-spin fa-spinner' : 'fa-search'
    },
    currentLanguage (): string {
      return i18n.locale
    },
    name (): string {
      let label = ''
      this.options.forEach(opt => {
        if (opt.id === this.currentValue) {
          label = opt.label
        }
      })
      return label
    }
  },
  watch: {
    currentLanguage () {
      this.loadStreetTypes()
    },
    name (newValue: string, oldValue: string) {
      if (newValue !== oldValue) {
        this.$emit('ValueName', newValue)
      }
    }
  },
  mounted () {
    this.loadStreetTypes()
  },
  methods: {
    loadStreetTypes (): void {
      const provider = new FetchStreetTypeCommandHandlerProvider()
      const command = new FetchStreetTypeCommand(this.currentLanguage)
      const handler = provider.provide()
      this.loading = true
      handler.handle(command)
        .then((response: StreetTypeDto[]) => {
          const options = response.map(current => {
            return { id: current.code, label: current.name }
          })
          this.options = options
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
})
